<template>
  <div class="HTML_RECENTACH">
    <div class="teamHeader">
      <span class="teamItem">
        <span class="teamLogo">
          <img :src="teamBaseInfor[0].teamLogo" />
        </span>
        <span class="teamName" v-text="teamBaseInfor[0].teamName"></span>
      </span>
      <span class="winLossInfor">
        <cup_svgSingleCircle
          v-if="cy"
          :currThemeObj="currThemeObj"
          teamMode="home"
          :cx="cx"
          :cy="cy"
          :strokeWidth="strokeWidth"
          :svgData="defaultSvgData"
          :keyArr="cup_svgSingleCircle_keyArr"
          dynamicClass="theme_HTML_RECENTACH"
          :svgCenterInforArr="['name']"
        ></cup_svgSingleCircle>
      </span>
    </div>
    <div
      class="recordList"
      :class="recordList.length > 5 ? 'heightScroll' : ''"
    >
      <span
        class="recordItemRow"
        v-for="(item, itemIndex) in recordList"
        :key="itemIndex"
      >
        <span class="recordItemRow_left" v-text="item.matchDate"></span>
        <span class="recordItemRow_mid">
          <span class="recordItemRow_mid_clo1" v-text="item.homeName"></span>
          <span class="recordItemRow_mid_clo2">
            <span
              class="recordItemRow_mid_clo2_clo1"
              :class="item.homeScore >= item.awayScore ? 'fontBold' : ''"
            >
              <NumberScrolling
                :tarVal="item.homeScore"
                :unit="''"
              ></NumberScrolling>
            </span>
            <span class="recordItemRow_mid_clo2_clo2" v-text="':'"></span>
            <span
              class="recordItemRow_mid_clo2_clo3"
              :class="item.awayScore >= item.homeScore ? 'fontBold' : ''"
            >
              <NumberScrolling
                :tarVal="item.awayScore"
                :unit="''"
              ></NumberScrolling>
            </span>
          </span>
          <span class="recordItemRow_mid_clo3" v-text="item.awayName"></span>
        </span>
        <!-- 核心改动：动态绑定胜平负的class，并优先展示competitionName -->
        <span class="recordItemRow_right" v-text="item.competitionName ?? item.phaseName"></span>
      </span>
    </div>
  </div>
</template>

<script>
// 近期战绩 篮球/足球通用
import NumberScrolling from '@components/compreSportsMeet/html/components/NumberScrolling'
import cup_svgSingleCircle from '@components/platfromBase/football/cup_svgSingleCircle.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'HTML_RECENTACH',
  props: {
    datas: {
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
          lose: null,
          win: null,
          draw: null, // 兼容足球的平局数据
        },
        statisticsModels: [],
        pictures: [],
        videos: [],
      }),
    },
  },
  mixins: [cup_base_data_mixin],
  components: {
    cup_svgSingleCircle,
    NumberScrolling,
  },
  data() {
    return {
      cup_svgSingleCircle_keyArr: ['name', 'val'],
      strokeWidthVw: 0.278,
      bodyWidth: 0,
      cxVw: 2.5,
      cyVw: 2.5,
    }
  },
  created() {
    this.bodyWidth = window.innerWidth
      ? window.innerWidth
      : window.screen.width
        ? window.screen.width
        : 375
  },
  computed: {
    strokeWidth() {
      return Math.ceil((this.bodyWidth / 100) * this.strokeWidthVw)
    },
    cx() {
      return Math.ceil((this.bodyWidth / 100) * this.cxVw)
    },
    cy() {
      return Math.ceil((this.bodyWidth / 100) * this.cyVw)
    },
    recordList() {
      return this.datas && this.datas.data && this.datas.data.dataList
        ? this.datas.data.dataList
        : []
    },
    // 兼容胜平负（足球）和胜/负（篮球）的统计圆环数据
    defaultSvgData() {
      let val = 0,
        name = '-',
        key = 1
      if (
        this.datas &&
        this.datas.data &&
        (this.datas.data.lose || this.datas.data.win || this.datas.data.draw)
      ) {
        const win = this.datas.data.win || 0
        const draw = this.datas.data.draw || 0
        const lose = this.datas.data.lose || 0
        const total = win + draw + lose

        // 计算胜率（或得分率）
        val = total > 0 ? Math.ceil((win / total) * 1000) / 10 : 0

        // 如果有平局数据，展示“胜平负”，否则只展示“胜负”
        if (this.datas.data.draw !== null && this.datas.data.draw !== undefined) {
          name = `${win}胜${draw}平${lose}负`
        } else {
          name = `${win}胜${lose}负`
        }
      }
      return {
        val,
        name,
        key,
      }
    },
    teamBaseInfor() {
      return this.datas && this.datas.objectInfo
        ? this.datas.objectInfo
        : [
          {
            teamId: null,
            teamLogo: '',
            teamName: '',
          },
        ]
    },
  },
  methods: {
    // 获取胜平负的文字
    getResultText(homeScore, awayScore) {
      if (homeScore === undefined || awayScore === undefined) return ''
      if (homeScore > awayScore) return '胜'
      if (homeScore === awayScore) return '平'
      return '负'
    },
    // 获取胜平负对应的颜色class
    getResultClass(homeScore, awayScore) {
      if (homeScore === undefined || awayScore === undefined) return ''
      if (homeScore > awayScore) return 'win'
      if (homeScore === awayScore) return 'draw'
      return 'lose'
    }
  },
}
</script>

<style lang="scss">
.HTML_RECENTACH {
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: calc(100% - 3.6vw);

  .teamHeader {
    width: 100%;
    height: auto;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
    color: var(--mixtmt_greyColor2);
    .teamItem {
      width: 60%;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      justify-content: center;
      .teamLogo {
        display: block;
        width: 2.778vw;
        height: 2.778vw;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .teamName {
        padding: 0 1.11vw;
        width: calc(100% - 2.778vw);
        font-size: 1.11vw;
        line-height: 1.66vw;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &:nth-child(2) {
        align-items: flex-end;
        .teamName {
          text-align: right;
        }
      }
    }
    .winLossInfor {
      width: 40%;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
  .recordList {
    width: 100%;
    &.heightScroll {
      height: 13.5vw;
      overflow: auto;
      .recordItemRow {
        margin-top: 0.694vw;
      }
    }
    .recordItemRow {
      display: block;
      margin-top: 0.533vw;
      padding: 0 0.694vw;
      width: 100%;
      height: 2.22vw;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      background-color: var(--mixtmt_greyColor8);
      color: var(--mixtmt_greyColor4);
      .recordItemRow_left {
        width: 6.25vw;
      }
      // 增加胜平负的颜色样式
      .recordItemRow_right {
        width: 4.16vw;
        text-align: center;
        font-weight: bold;
        &.win {
          color: #ff4d4f; // 胜：红色
        }
        &.draw {
          color: #999999; // 平：灰色
        }
        &.lose {
          color: #52c41a; // 负：绿色
        }
      }
      .recordItemRow_mid {
        width: calc(100% - 6.25vw - 4.16vw);
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        .recordItemRow_mid_clo1,
        .recordItemRow_mid_clo3 {
          width: calc(50% - 4vw);
          font-size: 0.974vw;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          color: var(--mixtmt_greyColor2);
        }
        .recordItemRow_mid_clo1 {
          text-align: right;
        }
        .recordItemRow_mid_clo2 {
          width: 8vw;
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: center;
          .recordItemRow_mid_clo2_clo1 {
            text-align: right;
          }
          .recordItemRow_mid_clo2_clo2 {
            width: 0.694vw;
            text-align: center;
          }
          .recordItemRow_mid_clo2_clo3 {
            text-align: left;
          }
          .recordItemRow_mid_clo2_clo1,
          .recordItemRow_mid_clo2_clo3 {
            width: calc(50% - 0.347vw);
            &.fontBold {
              font-weight: bold;
              color: var(--mixtmt_greyColor2);
            }
          }
        }
        .recordItemRow_mid_clo3 {
          text-align: left;
        }
      }
    }
  }
}
</style>